/**
 * Risk classification for anything an employee can do.
 *
 * Normative source: docs/architecture/contracts.md (Appendix A of the product
 * blueprint).
 *
 * The classes live here; what each one *requires* is policy and lives in
 * `@coworker/domain`. Splitting them keeps this package free of decisions a
 * client could recompute and get wrong.
 */
export const SIDE_EFFECTS = [
  'READ_ONLY',
  'DRAFT',
  'REVERSIBLE_WRITE',
  'EXTERNAL_COMMUNICATION',
  'FINANCIAL',
  'CODE_DEPLOY',
  'DESTRUCTIVE',
  'SECURITY',
] as const;

export type SideEffect = (typeof SIDE_EFFECTS)[number];

export type RiskLevel = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';

export type ApprovalRequirement = 'NEVER' | 'POLICY' | 'ALWAYS' | 'ADMIN_ONLY' | 'BLOCK';
